/**
 * Pull the keyword out of a PLP filter slug.
 *
 * The slug is `_`-joined segments and the keyword segment is the quoted one
 * (`toyota_'family suv'`). Read straight off the param rather than via
 * `mapFilterParamsToFormattedFilters`, which needs the Typesense-backed filter map.
 */
export const getKeywordFromFilterParam = (filter?: string): string => {
  if (!filter) {
    return '';
  }

  const keywordSegment = filter.split('_').find((segment) => segment.startsWith("'") && segment.endsWith("'"));

  if (!keywordSegment) {
    return '';
  }

  return decodeURI(keywordSegment).replace(/^'(.*)'$/, '$1');
};
